import React from "react";
import { Box, Button, Container, Typography, Stack } from "@mui/material";
import { Apple as AppleIcon, Android as AndroidIcon } from "@mui/icons-material";
import { ANDROID_APP_URL, IOS_APP_URL, SITE_NAME } from "../../seo/constants";
import { APP_ICON } from "../../seo/assets";

const AppDownloadCTA = ({
    title = `Download ${SITE_NAME}`,
    subtitle = "Your AI Islamic companion for Quran learning, prayer times, Qibla, daily ayat, and spiritual growth — free on iOS and Android.",
    showIcon = true,
}) => (
    <Box
        sx={{
            mt: { xs: 6, md: 8 },
            p: { xs: 3, md: 5 },
            borderRadius: 4,
            textAlign: "center",
            background:
                "linear-gradient(135deg, rgba(240,248,240,0.95) 0%, #ffffff 55%, rgba(218,165,32,0.08) 100%)",
            border: "1px solid rgba(46,139,87,0.15)",
            boxShadow: "0 12px 40px rgba(46,139,87,0.08)",
        }}
    >
        {showIcon && (
            <Box
                component="img"
                src={APP_ICON}
                alt={`${SITE_NAME} app icon`}
                sx={{
                    width: 72,
                    height: 72,
                    borderRadius: 3,
                    mb: 2,
                    boxShadow: "0 8px 24px rgba(46,139,87,0.25)",
                }}
            />
        )}
        <Typography variant="h4" component="h2" sx={{ mb: 1.5, fontWeight: 700 }}>
            {title}
        </Typography>
        <Typography
            variant="body1"
            sx={{
                mb: 3,
                maxWidth: 640,
                mx: "auto",
                color: "text.secondary",
                lineHeight: 1.7,
            }}
        >
            {subtitle}
        </Typography>
        <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
        >
            <Button
                variant="contained"
                size="large"
                startIcon={<AppleIcon />}
                href={IOS_APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ minWidth: { xs: "100%", sm: 220 }, maxWidth: 320 }}
            >
                Download for iPhone
            </Button>
            <Button
                variant="outlined"
                size="large"
                startIcon={<AndroidIcon />}
                href={ANDROID_APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    minWidth: { xs: "100%", sm: 220 },
                    maxWidth: 320,
                    borderWidth: 2,
                    "&:hover": { borderWidth: 2 },
                }}
            >
                Download for Android
            </Button>
        </Stack>
    </Box>
);

export const PageShell = ({ children, maxWidth = "md", narrow = false }) => (
    <Box
        sx={{
            background:
                "linear-gradient(180deg, rgba(240,248,240,0.55) 0%, #ffffff 28%, #ffffff 100%)",
            minHeight: "calc(100vh - 200px)",
            py: { xs: 4, md: 6 },
        }}
    >
        <Container maxWidth={narrow ? "sm" : maxWidth}>{children}</Container>
    </Box>
);

export default AppDownloadCTA;
